export const APP_NAME = 'login';
